// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3d0306hHE53U7y:focus {\n  border: none;\n  box-shadow: none;\n}\n._23ZDfgpiESvkX8 {\n  cursor: pointer;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.aKJZDs0FdlntgZ {\n  font-weight: 600;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unstyledLink": "_3d0306hHE53U7y",
	"link": "_23ZDfgpiESvkX8",
	"lozenge": "aKJZDs0FdlntgZ"
};
export default ___CSS_LOADER_EXPORT___;
